export const FREIGHT_DISPLAY_TYPES_FETCHED = 'FREIGHT_DISPLAY_TYPES_FETCHED';
export const FREIGHT_DISPLAY_TYPE_ADDED = 'FREIGHT_DISPLAY_TYPE_ADDED';
export const FREIGHT_DISPLAY_TYPE_UPDATE = 'FREIGHT_DISPLAY_TYPE_UPDATE';
